import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import * as sessionUserSelector from 'selectors/sessionUser'
import { userTimeZoneFormat } from 'utils/time'
import ComcastCopyright from 'components/Shared/ComcastCopyright/Index'
import colors from 'components/utils/colors'

import { FOOTER_HEIGHT } from 'constants/constants'

export const StyledFooter = styled.div`
  position: absolute;
  display: flex;
  flex: 1;
  height: ${FOOTER_HEIGHT}px;
  box-sizing: border-box;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: space-between;
  background: #FFFFFF4C; /* 30% opacity */
  min-width: 100%;
  padding: 0 32px;
  border-top: 1px solid ${colors.secondary90}4C; /* 30% opacity */
`

const LeftSection = styled.div`
  display: flex;
`

const RightSection = styled.div`
  display: flex;
`

const DataEntry = styled.div`
  display: flex;
  font-size: 12px;
  color: ${colors.secondary60};
  padding-right: 16px;
  white-space: nowrap;
`

const DataTitle = styled.div`
  font-weight: 600;
`

const DataValue = styled.div`
  padding-left: 4px;
`

const Footer = ({ className }) => {
  const { t } = useTranslation()
  const userIsAdmin = useSelector(sessionUserSelector.isAnyAdmin)
  const userTimeZone = useSelector(sessionUserSelector.timezone)

  const releaseVersion = process.env.RELEASE_TAG
  const gitHash = process.env.GIT_COMMIT_HASH
  const buildDateStrFull = userTimeZone ? userTimeZoneFormat(userTimeZone, process.env.BUILD_TIME_ISO) : null

  return (
    <StyledFooter className={className} data-test='app-footer'>
      <LeftSection data-test='app-footer-left-section'>
        <DataEntry>
          <DataTitle>{t('footer.releaseVersion')}:</DataTitle>
          <DataValue>{releaseVersion}</DataValue>
        </DataEntry>
        {userIsAdmin && (
          <DataEntry>
            <DataTitle>{t('footer.hash')}:</DataTitle>
            <DataValue>{gitHash}</DataValue>
          </DataEntry>
        )}
        {userIsAdmin && (
          <DataEntry>
            <DataTitle>{t('footer.deployedAt')}:</DataTitle>
            <DataValue>{buildDateStrFull}</DataValue>
          </DataEntry>
        )}
      </LeftSection>

      <RightSection data-test='app-footer-right-section'>
        <ComcastCopyright />
      </RightSection>
    </StyledFooter>
  )
}

export default Footer
